import React from "react"

import CardImage from "../components/cardImage"
import Heading from "../components/heading"

const ChiSiamo = () => (
  <>
    <Heading
        title="Chi siamo"
        text="Siamo un gruppo affiatato di professionisti che crede nella dedizione al lavoro, nella competenza e nella comprensione delle esigenze dei clienti quali cardini fondamentali per plasmare le migliori strategie difensive."
    />
      <div className="row">
        <div className="col-12 col-xl-8 offset-xl-2">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 col-sm-6 card-wrapper">
          <CardImage
            img="https://via.placeholder.com/192x256"
            title="Francesco Salomoni"
            subtitle="Avvocato"
            text="Si è laureato in Giurisprudenza presso l’Università di Modena e Reggio Emilia.<br>
            È avvocato dal 1993."
          />
          </div>
          <div className="col-lg-12 col-sm-6 card-wrapper">
          <CardImage
            img="https://via.placeholder.com/192x256"
            title="Elisabetta Preci"
            subtitle="Avvocato"
            text="Si è laureata in Giurisprudenza con lode presso l’Università di Modena e Reggio Emilia.<br>
            È avvocato dal 2012."
          />
          </div>
          <div className="col-lg-12 col-sm-6 card-wrapper">
          <CardImage
            img="https://via.placeholder.com/192x256"
            title="Pietro Puliatti"
            subtitle="Avvocato"
            text="Si è laureato in Giurisprudenza con lode presso l’Università di Modena e Reggio Emilia.<br>
È stato visiting student presso la <em>Hofstra Law School</em> di Hempstead, NY.<br>
Ha conseguito il titolo di Dottore di ricerca in Diritto del Lavoro presso l’Università di Padova.<br>
È avvocato dal 2012."
          />
          </div>
          <div className="col-lg-12 col-sm-6 card-wrapper">
          <CardImage
            img="https://via.placeholder.com/192x256"
            title="Salvatore Puliatti"
            subtitle="Professore Avvocato"
            text="Si è laureato in Giurisprudenza con lode e dignità di stampa presso l’Università di Modena e Reggio Emilia.<br> Ha insegnato materie romanistiche presso le Facoltà di Giurisprudenza dell’Università di Messina, di Modena e Reggio Emilia e dell’Università Cattolica del Sacro Cuore.<br> È Professore Ordinario di Diritto Romano presso l’Università di Parma.<br> È avvocato dal 1981."
          />
          </div>
          <div className="col-lg-12 col-sm-6 card-wrapper">
          <CardImage
            img="https://via.placeholder.com/192x256"
            title="Eugenia Franciosi"
            subtitle="Professore Avvocato"
            text="Si è laureata in Giurisprudenza con lode presso l’Università di Modena e Reggio Emilia.<br>
            In qualità di ricercatrice confermata ha insegnato materie romanistiche presso la Facoltà di Giurisprudenza dell’Università di Bologna.<br>
            È avvocato dal 1981."
          />
          </div>
          <div className="col-lg-12 col-sm-6 card-wrapper">
          <CardImage
            img="https://via.placeholder.com/192x256"
            title="Michela De Santis"
            subtitle="Avvocato"
            text="Si è laureata in giurisprudenza presso l’Università Commerciale Luigi Bocconi.<br>
Ha conseguito il titolo di Dottore di ricerca in Scienze Giuridiche presso l’Università di Modena e Reggio Emilia.<br>
È stata visiting student presso l’Institut de recherche juridique de la Sorbonne (IRJS), Paris I – Panthéon Sorbonne.<br>
È stata assegnista di ricerca nei settori di diritto commerciale / diritto processuale civile nell’Università di Modena e Reggio Emilia ed è autrice di pubblicazioni scientifiche del settore.<br>
È docente a contratto di Insolvency Law nell’Università di Modena e Reggio Emilia.<br>
È avvocato dal 2014."
          />
          </div>
          <div className="col-lg-12 col-sm-6 card-wrapper">
          <CardImage
            img="https://via.placeholder.com/192x256"
            title="Cecilia Bondi"
            subtitle="Avvocato"
            text="Si è laureata in Giurisprudenza con lode presso l’Università di Modena e Reggio Emilia.<br>
È stata <em>visiting student</em> presso la Facultad de Derecho della Universidad Pompeu Fabra di Barcellona e presso la School of Law della Liverpool John Moores University.<br>
Ha conseguito il titolo di Dottore di ricerca europeo in Scienze Giuridiche presso l’Università di Modena e Reggio Emilia.<br>
È avvocato dal 2014."
          />
          </div>
          <div className="col-lg-12 col-sm-6 card-wrapper">
          <CardImage
            img="https://via.placeholder.com/192x256"
            title="Giulia Mattioli"
            subtitle="Avvocato"
            text="Si è laureata in Giurisprudenza con lode presso l’Università di Modena e Reggio Emilia nel 2012.<br>
Ha conseguito il titolo di Specialista in Studi sulla Pubblica Amministrazione presso la Scuola di specializzazione in Studi sull’Amministrazione Pubblica SPISA Alma Mater Studiorum Bologna, con lode nel 2012.<br>
Ha conseguito il titolo di Dottore di Ricerca in Diritto Amministrativo presso l’Università degli Studi di Udine e Trieste nel 2020.<br>
Attualmente è Ricercatrice a tempo determinato in Diritto Amministrativo presso il Dipartimento di Economia e Management dell’Università degli Studi di Ferrara e titolare di diversi insegnamenti, nonché vicedirettore del Master executive II livello, interateneo tra l’Università di Ferrara e l’Università di Milano La Statale, in materia di contrattualistica pubblica, prevenzione della corruzione, sostenibilità ed innovazione.<br>
È stata visiting professor presso alcune Università straniere, è membro scientifico di centri di ricerca e del comitato redazionale di riviste giuridiche, risulta autrice di pubblicazioni su tematiche di diritto amministrativo, nonché relatrice a master, convegni, seminari e scuole di formazione e specializzazione in Italia ed all’estero.<br>
Si occupa in generale di questioni di diritto amministrativo, con particolare riguardo a: contratti pubblici, accordi amministrativi, ambiente ed energia, urbanistica, servizi pubblici, società pubbliche, cave e beni pubblici, espropri, sanzioni amministrative.<br>
È avvocato dal 2014."
          />
          </div>
          <div className="col-lg-12 col-sm-6 card-wrapper">
          <CardImage
            img="https://via.placeholder.com/192x256"
            title="Simone Biondo"
            subtitle="Praticante avvocato"
            text="Si è laureato in Giurisprudenza con lode presso l’Università di Modena e Reggio Emilia."
          />
          </div>
          </div>
          </div>
        </div>
      </div>
    </>
)

export default ChiSiamo
